import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import InstructorStudentCalendar from "@/components/calendar/InstructorStudentCalendar";
import TutoringCalendar from "@/components/tutoring/TutoringCalendar";

export default function InstructorCalendar() {
  const { user } = useAuth();
  return (
    <div className="container mx-auto px-4 py-8 space-y-6">
      <header>
        <h1 className="text-3xl font-bold">Calendar</h1>
        <p className="text-muted-foreground">Your students' shared schedule and tutoring sessions.</p>
      </header>
      <InstructorStudentCalendar />
      <Card>
        <CardHeader>
          <CardTitle>Tutoring Schedule Calendar</CardTitle>
          <CardDescription>View your tutoring session schedule</CardDescription>
        </CardHeader>
        <CardContent>
          <TutoringCalendar instructorId={user?.id || ""} isInstructor={true} />
        </CardContent>
      </Card>
    </div>
  );
}
